export default {
  '锻炼记录列表':'Exercise Record List',
  '视频不存在':'The video does not exist.',
}